import React, { useEffect, useState } from 'react';
import { Grid, Typography, TextField, Button } from '@material-ui/core';

const Home = (props) => {

    const [userName, setUserName] = useState('');

    const userNameChange = (e) => {
        setUserName(e.target.value);
    }

    const button =
    {
        textTransform: "none"
    }

    const styles = {
        width: "100%",
    }

    const sendEmail = () => {
        fetch('api/Users/registeruser', {
            method: 'POST',
            headers:
            {
                'Content-Type': 'application/json'
            },
            body:
                JSON.stringify({
                    "useremail": props.prop1.userEmail,
                    "username": userName
                })

        }).then((response) => {
            if (response.status === 200) {
                console.log(response.status);
                fetch('/sendregmail/' + props.prop1.userEmail)
                props.history.push('/finreg')
            }
            else {
                props.history.push('failreg');
            }
        });

    }

    const emailChange = (e) => {

        props.prop2.setUserEmail(e.target.value);
    }

    const registerUser = (e) => {
        sendEmail();

    }

    useEffect(() => {
    }, [])


    return (
        <Grid container justify="center">
            <Grid item>
                <Grid container justify="center">

                    <Typography variant="h4" gutterBottom>
                        ATKV - Projekte - Registrasie
            </Typography>
                    <TextField onChange={userNameChange} id="ouerNaamVan" required label="Naam en van" variant="outlined" margin="normal" fullWidth />
                    <TextField onChange={emailChange} id="ouerNaamVan" required label="E-posadres" variant="outlined" margin="normal" fullWidth />
                    <Button variant="contained" color="primary" onClick={registerUser} disabled={props.prop1.userEmail === "" ? true : false}>Registreer</Button>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Registration.js